"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GenericChartComponent = require("../GenericChartComponent");

var _GenericChartComponent2 = _interopRequireDefault(_GenericChartComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SVGComponent = function (_Component) {
	_inherits(SVGComponent, _Component);

	function SVGComponent() {
		_classCallCheck(this, SVGComponent);

		return _possibleConstructorReturn(this, (SVGComponent.__proto__ || Object.getPrototypeOf(SVGComponent)).apply(this, arguments));
	}

	_createClass(SVGComponent, [{
		key: "render",
		value: function render() {
			var children = this.props.children;

			return _react2.default.createElement(_GenericChartComponent2.default, {
				drawOn: [],
				svgDraw: children
			});
		}
	}]);

	return SVGComponent;
}(_react.Component);

SVGComponent.propTypes = {
	children: _propTypes2.default.func.isRequired
};

exports.default = SVGComponent;
//# sourceMappingURL=SVGComponent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-stockcharts/lib/series/SVGComponent.js
// module id = 403
// module chunks = 0